const React = require('react');
const getAdsIds = require('./search-results-ad-util');

class AdTag extends React.Component {
  constructor() {
    super();
    this.updateAdTagIds.bind(this);
    this.displayAds.bind(this);
    window.googletag = window.googletag || { cmd: [] };
    this.state = {
      adTagIds: getAdsIds()
    };
  }

  componentDidMount() {
    this.displayAds();
    window.addEventListener('resize', () => this.updateAdTagIds());
  }

  componentDidUpdate() {
    this.displayAds();
  }

  displayAds() {
    const { adTagIds } = this.state;

    const { googletag } = window;
    // mobile view: one ad tag
    if (adTagIds.SINGLE) {
      const { SINGLE: { DIV, SLOT }, SIZE } = adTagIds;
      googletag.cmd.push(function () {
        googletag.defineSlot(SLOT, SIZE, DIV).addService(googletag.pubads());
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().setTargeting('search', []);
        googletag.enableServices();
      });
      googletag.cmd.push(function () { googletag.display(DIV); });
    } else {  // non-mobile view: two tags
      const { RIGHT, LEFT, SIZE } = adTagIds;
      googletag.cmd.push(function () {
        googletag.defineSlot(LEFT.SLOT, SIZE, LEFT.DIV).addService(googletag.pubads());
        googletag.defineSlot(RIGHT.SLOT, SIZE, RIGHT.DIV).addService(googletag.pubads());
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().setTargeting('search', []);
        googletag.enableServices();
      });
      googletag.cmd.push(function () { googletag.display(RIGHT.DIV); });
      googletag.cmd.push(function () { googletag.display(LEFT.DIV); });
    }
  }

  getDeskDiv(adTagIds) {
    const { RIGHT, LEFT } = adTagIds;
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div id={LEFT.DIV} />
        <div id={RIGHT.DIV} />
      </div>
    );
  }

  getMobileDiv(adTagIds) {
    const { SINGLE: { DIV } } = adTagIds;
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div id={DIV} />
      </div>
    );
  }

  updateAdTagIds() {
    const adTagIds = getAdsIds();
    const preAdTagIds = this.state.adTagIds;
    if (preAdTagIds.SIZE[0] === adTagIds.SIZE[0]) {
      return;
    }

    window.googletag.destroySlots();
    this.setState({ adTagIds });
  }

  render() {
    const { adTagIds } = this.state;
    if (adTagIds.SINGLE) {
      return this.getMobileDiv(adTagIds);
    }

    return this.getDeskDiv(adTagIds);
  }
}

module.exports = AdTag;
